<p-toast
  class="bl-toast bl-toast--success"
  key="successMessageAfsReview"
  closable="true"
  [escape]="true"
>
  <ng-template let-message pTemplate="message">
    <span class="ui-toast-icon template-position">
      <i class="fas fa-check"></i>
    </span>
    <div class="ui-toast-message-text-content">
      <h3 class="ui-toast-summary">Success</h3>
      <span class="ui-toast-detail"
        >Analysis completed.
        <a class="link-style">{{ templateSuccess.scoreTemplate }}</a>
        to see the results</span
      >
    </div>
  </ng-template>
</p-toast>
<p-toast
  class="bl-toast bl-toast--error"
  key="errorMessageAfsReviewTable"
  closable="true"
></p-toast>
<div class="col-12 t-padding-right-0 t-padding-left-0" *ngIf="tableButtons">
  <div class="col-6"></div>
  <div class="col-6 t-padding-right-0">
    <div class="bl-table-legend__content-button-right">
      <button
        [disabled]="disabledButton == false"
        class="bl-button--btn-reject bl-button--btn-reject--lg"
        type="submit"
        (click)="showModalDialog()"
      >
        Reject
      </button>
      <button
        [disabled]="disabledButton == false"
        class="bl-button--btn-finish bl-button--btn-finish--lg"
        type="submit"
        (click)="showModalDialog()"
      >
        Aprove
      </button>
    </div>
  </div>
</div>
<p-dialog
  styleClass="bl-modal"
  header="Update Status of Actions"
  [(visible)]="displayModal"
  [modal]="true"
  [responsive]="true"
  [baseZIndex]="10000"
  [positionTop]="90"
  [positionLeft]="390"
>
  <div class="col-lg-12 col-md-11 col-sm-11 bl-generate-action-plan--modal-container">
    <div class="bl-select">
      <label class="col-lg-3 bl-select__label">Item</label>
      <span class="col-lg-8">1</span>
    </div>
  </div>
  <div class="col-lg-12 col-md-11 col-sm-11 bl-generate-action-plan--modal-container">
    <div class="bl-select">
      <label class="col-lg-3 bl-select__label">Action</label>
      <p-dropdown
        [options]="actions"
        [(ngModel)]="selectedAction"
        placeholder="Select an option"
        optionLabel="name"
        [showClear]="true"
        class="col-lg-8"
        styleClass="bl-dropdown size-dropdown"
      ></p-dropdown>
    </div>
  </div>
  <div class="col-lg-12 col-md-11 col-sm-11 bl-generate-action-plan--modal-container">
    <div class="bl-select">
      <label class="col-lg-3 bl-select__label">Status</label>
      <p-dropdown
        [options]="status"
        [(ngModel)]="selectedStatus"
        placeholder="Select an option"
        optionLabel="name"
        [showClear]="true"
        styleClass="bl-dropdown size-dropdown"
        class="col-lg-8"
      ></p-dropdown>
    </div>
  </div>
  <div class="col-lg-12 col-md-11 col-sm-11 bl-generate-action-plan--modal-container">
    <div class="bl-select">
      <label class="col-lg-3 bl-select__label">Comments</label>
      <textarea
        inputId="textarea"
        rows="3"
        cols="30"
        pInputTextarea
        class="col-lg-8 bl-textarea textarea-container-modal--size-small"
        placeholder="Add comment..."
      ></textarea>
      <label for="textarea" class="hide-accessible">Textarea</label>
    </div>
  </div>
  <div class="col-lg-12 col-md-11 col-sm-11 bl-generate-action-plan--modal-container">
    <label class="col-lg-3 bl-select__label">Evidence</label>
    <p-fileUpload
      multiple="multiple"
      chooseLabel="Select file"
      styleClass="bl-generate-action-plan__upload"
      [showUploadButton]="false"
      [showCancelButton]="false"
      class="col-lg-5"
      (click)="isSelectFile()"
    ></p-fileUpload>
    <label *ngIf="!selectFile" class="col-lg-4 bl-generate-action-plan--label"
      >No select file...</label
    >
  </div>
  <div class="bl-button--btn-container">
    <button
      pButton
      (click)="displayModal = false"
      label="Cancel"
      class="bl-button--btn-cancel-modal bl-button--position-right"
    ></button>
    <button
      pButton
      (click)="displayModal = false"
      class="bl-button--btn-save-modal bl-button--position-right"
      label="Save"
    ></button>
  </div>
</p-dialog>
<br />
<br />
<div class="bl-table">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="item_id">
      <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 5%">Item</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <a class="tooltip top">
          {{ element.item_id }}
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="finding">
      <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 16%">
        Finding
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="bl-textarea">
          <ng-container>
            <label></label>
            <textarea
              class="textarea__area-modal--size-small textarea__area-modal--color-table"
              disabled
            >
                  {{ element.finding }}
                  </textarea
            >
          </ng-container>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="recommendation">
      <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 16%">
        Recommendation
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="bl-textarea">
          <ng-container>
            <label></label>
            <textarea
              class="textarea__area-modal--size-small textarea__area-modal--color-table"
              disabled
            >
            {{ element.recommendation }}
            </textarea>
          </ng-container>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="comments">
      <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 16%">
        Comments
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="bl-textarea">
          <ng-container>
            <label></label>
            <textarea
              class="textarea__area-modal--size-small textarea__area-modal--color-table"
              disabled
            >
            {{ element.comments }}
            </textarea>
          </ng-container>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="actionsDE">
      <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 15%">
        Actions defined by the Executor
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="bl-textarea">
          <ng-container>
            <textarea class="textarea__area-modal--size-small textarea__area-modal--color-table">
                {{ element.actionsDE }}
                </textarea
            >
          </ng-container>
          <br />
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="responsable">
      <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 10%">
        Responsible
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="field-container">
          <div class="position-input">
            <input
              class="input__text--size-small input__text--color-table"
              id="responsableTitle"
              type="text"
              pInputText
              [(ngModel)]="element.responsable"
            />
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="estimatedID">
      <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 16%">
        Estimated implementation date
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="field-container">
          <div class="datepicker-formfield">
            <mat-form-field [formGroup]="estimateDate" appearance="fill">
              <input
                class="date-datepicker space-date combobox"
                matInput
                formControlName="start"
                [matDatepickerFilter]="myFilter"
                [matDatepicker]="picker"
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="meansV">
      <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 8%">
        Means of verification
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="field-container">
          <div class="formfield-combobox">
            <mat-form-field appearance="fill">
              <mat-select>
                <mat-option>In process</mat-option>
                <mat-option class="disabled-combobox" *ngFor="let item of states" [value]="item">{{
                  item.name
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <a *ngIf="!scoreScreen" (click)="backToTop()" class="bl-anchor"  style="bottom: 0.5em;">
    <div class="bl-anchor__arrow"></div>
    <div class="bl-anchor__square">Back to top</div>
  </a>
</div>
